import api from "./api";

class SettingService {
  async getDataPage(params) {
    
      return await this.getListCustomerSource(params);
   
  }

  async updateOrCreateSource(item) {
    if (item.id) {
      return await api.put(`/setting/customer-source/create/${item.id}`, item);
    } else {
      return await api.post("/setting/customer-source/create", item);
    }
  }
  async destroy(item){
    const response = await api.delete("/setting/delete/"+item.id);
    return response;
  }
  async changeStatus(item){
  
        return this.updateOrCreateSource(item)  
  }
  async getCustomerData() {
    const response = await api.get("/setting/customer-source?type=all");
    return response.data.data;
  }

  async getListCustomerSource(params) {
    const response = await api.get("/setting/customer-source", { params });
    return response;
  }

  async getOptions(params) {
    const response = await api.get("/options", { params });
    return response;
  }

  async updateOptions(type, data) {
    const response = await api.post("/options/update", { type, data });
    return response;
  }

  async getSettings(params) {
    const response = await api.post("/setting", params);
    return response;
  }
}

export default new SettingService();
